import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { NodeStatus } from './PoolNodeStates';
import { PoolNodeStatus } from './PoolNodeStatus';

export type PoolNodePresenceIconProps = Readonly<{
  status: PoolNodeStatus;
  poolNodeStatus: { readonly [s in PoolNodeStatus]: NodeStatus };
}>;

export function PoolNodePresenceIcon(props: PoolNodePresenceIconProps) {
  const { status: state, poolNodeStatus } = props;
  return <img
      className={statusIconClass}
      title={poolNodeStatus[state].stateText}
      src={imgPath(poolNodeStatus[state].stateImage)}
      alt={''}
    />;
}

export const statusIconClass = style({
  verticalAlign: 'text-bottom',
  marginRight: TabStyles.Spacing.DefaultSpace
});
